// @ts-strict-ignore
import React, { createContext, useContext, useMemo, useState } from 'react'

interface FiatSendContextState {
  transactionId: string | null
  setTransactionId: (id: string | null) => void
}

const FiatSendContext = createContext<FiatSendContextState>(null)

export const FiatSendProvider = ({ children }: { children: React.ReactNode }) => {
  const [transactionId, setTransactionId] = useState<string | null>(null)

  const value = useMemo(() => ({ transactionId, setTransactionId }), [transactionId])

  return <FiatSendContext.Provider value={value}>{children}</FiatSendContext.Provider>
}

export const useFiatSendContext = () => {
  const context = useContext(FiatSendContext)
  if (!context) {
    throw new Error('useFiatSendContext must be used within a FiatSendProvider')
  }
  return context
}
